module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.7854/img/callout-blobs.svg"